import { Routes, Route } from "react-router-dom";
import LocationPlanning from "./LocationPlanning";
import LocationOccupationOverview from "./occupation/LocationOccupationOverview";

const index = () => {
	return (
		<Routes>
			<Route index element={<LocationPlanning />} />
			<Route path='/occupation' element={<LocationOccupationOverview />} />
		</Routes>
	);
};

export default index;
